<script setup></script>

<template>
  <VApp>
    <VMain>
      <router-view></router-view>
    </VMain>
  </VApp>
</template>
